export default {
  lotese: {
    name: 'lotese',
    style: require('@/themes/lotese/style.scss'),
    logo: require('@/themes/lotese/logo.svg'),
    logoLight: require('@/themes/lotese/logo-dark.png')
  },
  betsul: {
    name: 'betsul',
    style: require('@/themes/betsul/style.scss'),
    logo: require('@/themes/betsul/logo.svg'),
    logoLight: require('@/themes/betsul/logo-light.svg')
  }
};
